import script from "./FooterComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./FooterComponent.vue?vue&type=script&lang=ts&setup=true"

import "./FooterComponent.vue?vue&type=style&index=0&id=57a0f843&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57a0f843"]])

export default __exports__